<template>
  <div :key="reload">
    <base-header class="pb-6 pb-8 pt-5 pt-md-6">
      <h1 class="text-center">Panel de Configuración</h1>
      <h1>Áreas</h1>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <router-link
                class="btn btn-primary px-4"
                :to="{
                  name: 'areasNew',
                }"
                >
                Agregar área
              </router-link>
            </b-card-header>
            <base-input
              type="text"
              placeholder="Buscar"
              v-model="search"
              name="buscar"
              style="max-width: 300px; margin-left: 20px;"
            >
            </base-input>
            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      :data="pagedTableData">
                <el-table-column label="Id Área"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <router-link
                            :to="{
                              name: 'areasEdit',
                              params: { areasId: row.id },
                            }">
                                {{row.id}}
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Nombre"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.name}}
                        </b-media>
                    </template>
                </el-table-column>

                <el-table-column label=""
                          prop=""
                          width="50px"
                          style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <router-link
                            :to="{
                              name: 'areasEdit',
                              params: { areasId: row.id },
                            }">
                                <img src="img/theme/icn_edit.svg" alt="">
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label=""
                          prop=""
                          width="80px"
                          style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;"
                          >
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <a class="page-link" @click="deleteElement(row.id)"><img src="img/theme/icn_delete.svg" alt=""></a>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="10" @change="setPage"  :total="areas.length"></base-pagination>
            </b-card-footer>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    data() {
      return {
        areas: [],
        token:'',
        user:'',
        currentPage: 1,
        pageSize: 10,
        reload: 0,
        search: ''
      };
    },
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    created () {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.areas) {
          let tempArea = []

          Object.keys(response.data.areas).map((key) => [response.data.areas[key]]).map(function(value) {
              tempArea.push(value[0])
          })
          this.areas = tempArea
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    computed: {
      pagedTableData() {
        return this.areas.filter(data => this.search ? data.name.toLowerCase().includes(this.search.toLowerCase()) : data).slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      }
    },
    methods : {
      setPage (val) {
        this.currentPage = val
      },
      deleteElement(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.areas.findIndex(x => x.id === index)
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_area',
            a_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.areas.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style>
.el-table, a{
  color: #112357;
}
.el-table_1_column_3,
.el-table_1_column_4,
.el-table_2_column_7,
.el-table_2_column_8{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.el-table a,
.el-table a:hover,
.el-table a:focus{
  border: none !important;
  background: none !important;
}
</style>
